import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fitness } from '../services/api';

// Aterragem do OAuth Huawei. A Huawei redireciona para aqui com ?code&state (ou ?error).
// Fazemos POST server-side (o backend valida o state e troca o code por tokens — que ficam SÓ no
// servidor, cifrados). Nunca guardamos code/state/tokens em localStorage/sessionStorage; removemos
// os parâmetros da navegação com replace assim que o pedido termina.
export default function HuaweiCallbackPage() {
  const nav = useNavigate();
  const [msg, setMsg] = useState('A concluir a ligação à Huawei…');
  const [failed, setFailed] = useState(false);
  const ran = useRef(false); // evita duplo POST (StrictMode/re-render)

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const oauthError = params.get('error'); // erro OAuth esperado (ex.: access_denied)

    const finish = (ok, message) => {
      // Limpa code/state da URL (não deixar credenciais transitórias na navegação/histórico).
      window.history.replaceState(null, '', '/fitness/huawei/callback');
      if (ok) { nav('/smartwatch', { replace: true }); return; }
      setFailed(true); setMsg(message);
      setTimeout(() => nav('/smartwatch', { replace: true }), 2500);
    };

    if (oauthError) { finish(false, `Ligação cancelada (${oauthError}).`); return; }
    if (!code || !state) { finish(false, 'Callback inválido: faltam parâmetros.'); return; }

    fitness.huaweiCallback(state, code)
      .then(() => finish(true))
      .catch((e) => finish(false, e?.response?.data?.message || 'Falha ao concluir a ligação.'));
  }, [nav]);

  return (
    <div style={S.wrap} role="status" aria-live="polite">
      <div style={{ ...S.title, color: failed ? '#b91c1c' : '#111827' }}>{msg}</div>
      {failed && <div style={S.sub}>A redirecionar…</div>}
    </div>
  );
}

const S = {
  wrap: { maxWidth: 480, margin: '0 auto', padding: 16, textAlign: 'center', paddingTop: 80 },
  title: { fontSize: 18, fontWeight: 600 },
  sub: { marginTop: 8, color: 'var(--text-secondary)', fontSize: 14 },
};
